export const fonts = {
  WalsheimTrial: 'GT Walsheim Trial',
  Walsheim: 'GT Walsheim',
}
